import { useEffect, useState } from 'react';
import { RightOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router-dom';
import OrganizationItem from './OrganizationItem';
import { sysLoginChange } from '&/api/Dialogs/signUpDlg';
import {} from '&/utils/common';
import HDLogo from '@/assets/img/HDLogo.png';
import { inject, observer } from 'mobx-react';
import './index.scss';

function HddOrganizationSelect(props) {
    const { appStore } = props;

    const his = useHistory();
    const userLoginData = JSON.parse(sessionStorage.getItem('HDDLoginData'));
    const { userinfo } = userLoginData;
    const { mobile, haveEnt, havePerson, enterpriseSelects } = userinfo;
    // console.log(userLoginData)

    const [showAll, setShowAll] = useState(false);

    useEffect(() => {}, []);
    useEffect(() => {
        initPage();
    }, [userLoginData]);

    const initPage = () => {};
    const getUserAvatarClass = item => {
        const classMap = {
            1: 'designer',
            2: 'project-manager',
        };
        return classMap[item.roleId] || 'other';
    };
    const selectOrigin = async enterpriseId => {
        try {
            const sendData = {
                enterpriseId,
            };
            const { data } = await sysLoginChange(sendData);
            data.rememberMe = userLoginData.rememberMe;
            data.userinfo.enterpriseId = enterpriseId;
            selectSuccess(data);
        } catch (e) {
            console.log('selectErr', e);
        }
    };
    const selectSuccess = data => {
        data.isRegister = 2;
        if (window?.external?.DispatchFun) {
            window?.external?.DispatchFun(
                'Login',
                'LoginSuccess',
                JSON.stringify(data)
            );
        }
    };
    const gotoApply = () => {
        window.external.DispatchFun(
            'Login',
            'ApplyEnterpriseVersion',
            window.location.origin + '/b/home?applyEnterprise=true'
        );
    };

    return (
        <div className="hdd-organization-select signInAndSignUpWrapper">
            <div className="container">
                <div
                    className="back-btn"
                    onClick={async () => {
                        await appStore.logout();
                        his.goBack();
                    }}>
                    <RightOutlined rotate={180} style={{ color: '#999' }} />
                    {intl.get('base.goBack')}
                </div>
                <h3>{intl.get('signUpSignIn.enterBusinesses')}</h3>
                <div className="organization-content">
                    <p className="content-title">
                        {intl.getHTML('signUpSignIn.boundAccount', {
                            phone: `${mobile.slice(0, 4)}******${mobile.slice(
                                -2
                            )}`,
                        })}
                    </p>
                    {havePerson && (
                        <OrganizationItem
                            className="personal-item"
                            itemData={{
                                name: intl.get('signUpSignIn.personalEditionS'),
                                roleName: userinfo.username,
                                url: userinfo.headUrl || HDLogo,
                            }}
                            click={() => selectSuccess(userLoginData)}
                        />
                    )}
                    {haveEnt && enterpriseSelects?.length > 0 && (
                        <div className="organization-list">
                            <h4 className="organization-list-title">
                                {intl.get('pages.corporateAccount')}
                            </h4>
                            {enterpriseSelects.map((item, index) => {
                                if (!showAll && index > 1) return '';
                                const itemData = {
                                    name: item.branchName || item.name,
                                    roleName: item.roleName,
                                    roleClass: getUserAvatarClass(item),
                                };
                                return (
                                    <OrganizationItem
                                        className="company-item"
                                        key={index}
                                        itemData={itemData}
                                        click={() => {
                                            selectOrigin(
                                                item.branchId ||
                                                    item.enterpriseId
                                            );
                                        }}
                                    />
                                );
                            })}
                        </div>
                    )}
                </div>
                {!haveEnt && (
                    <p className="apply-btn" onClick={gotoApply}>
                        {intl.get('signUpSignIn.applyTrialEnterpriseVersion')}
                    </p>
                )}
                {haveEnt && enterpriseSelects?.length > 2 && !showAll && (
                    <div
                        className="show-all-btn"
                        onClick={() => {
                            setShowAll(true);
                        }}>
                        <p>
                            {intl.get('signUpSignIn.spreadEnterprise', {
                                num: enterpriseSelects.length - 2,
                            })}
                        </p>
                        <RightOutlined rotate={90} style={{ color: '#999' }} />
                    </div>
                )}
            </div>
        </div>
    );
}

export default inject('appStore')(observer(HddOrganizationSelect));
